// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2n8T9","label":"LabeledBox_label__2vOq7"};